import BackButton from '../../components/BackButton';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import BookOutlinedIcon from '@mui/icons-material/BookOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import TopicOutlinedIcon from '@mui/icons-material/TopicOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import FormatQuoteOutlinedIcon from '@mui/icons-material/FormatQuoteOutlined';
import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import ContentPasteSearchOutlinedIcon from '@mui/icons-material/ContentPasteSearchOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Tooltip from '@mui/material/Tooltip';
import { useState, useEffect, useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import Card from '../../components/Card/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from '../../components/Spinner';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { useCategory } from '../../CategoryContext';
import { Context } from '../../AuthContext';
import AlertDialog from '../../components/AlertDialog';
import { useDeleteContent } from './useDeleteContent';
import './DetailCard.css';

const PublicationPage = ({ category = 'paper' }) => {
  const { updateCount, isEditor } = useCategory();
  const { user } = useContext(Context);
  const { handleDelete } = useDeleteContent();
  const [show, setShow] = useState();
  const navigate = useNavigate();

  const icons = {
    authors: <PeopleOutlinedIcon className="detail-icon" style={{ color: 'green' }} />,
    venue: <BookOutlinedIcon className="detail-icon" />,
    publicationDate: <CalendarMonthOutlinedIcon className="detail-icon" />,
  };

  const [item, setItem] = useState({});
  const [loading, setLoading] = useState(true);

  const { vertical_id, id } = useParams();

  useEffect(() => {
    if (!user) return;

    const getItem = async () => {
      const item = await fetchItem();
      if (!item) return;
      setItem(item.data);
      document.title = item.data.title + ' - The Simple Platform';
      setShow(item.data.show);
      setLoading(false);
    };
    getItem();
  }, [id, user, vertical_id]);

  const fetchItem = async () => {
    const token = await user.getIdToken();
    const url =
      process.env.REACT_APP_FLASK_WEBSERVER +
      `get_${category}_details?id=${id}&vertical_id=${vertical_id}`;

    const itemRequest = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    if (itemRequest.status === 403) {
      navigate('/forbidden', { replace: true });
      return null;
    }
    const item = await itemRequest.json();

    const bookmark_status_endpoint =
      process.env.REACT_APP_FLASK_WEBSERVER + `get_bookmark_id/${item?.data?._id}`;
    const bookmarkRequest = await fetch(bookmark_status_endpoint, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const bookmark = bookmarkRequest.ok ? await bookmarkRequest.json() : { isBookmarked: false };

    const result = {
      ...item,
      data: {
        ...item.data,
        isBookmarked: bookmark.isBookmarked,
      },
    };

    return result;
  };

  function editContent(event) {
    event.stopPropagation();
    navigate('edit');
  }

  const hideContent = async (event) => {
    event.stopPropagation();
    if (!user) return;

    const isChecked = !show;
    if (isChecked) {
      updateCount(category + 's', 1);
    } else {
      updateCount(category + 's', -1);
    }
    setShow(isChecked);
    const token = await user.getIdToken();

    const res = await fetch(
      process.env.REACT_APP_FLASK_WEBSERVER +
        'change_visibility?id=' +
        item._id +
        '&collection=' +
        category +
        's&vertical_id=' +
        vertical_id,
      {
        method: 'PATCH',
        headers: {
          'Content-type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ show: isChecked }),
      }
    );
    await res.json();
  };

  const toggleBookmark = async (event, itemId, category) => {
    event.stopPropagation();
    setItem({ ...item, isBookmarked: !item.isBookmarked });

    try {
      let vid = vertical_id;
      const token = await user.getIdToken();

      await fetch(`${process.env.REACT_APP_FLASK_WEBSERVER}toggle_bookmark`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: user.uid,
          item_id: itemId,
          category: `${category}s`,
          vertical_id: vid,
        }),
      });
    } catch (error) {
      console.error('Failed to toggle bookmark:', error);
    }
  };

  let urlPrefix = '/vertical/' + vertical_id + '/';

  return loading ? (
    <Spinner />
  ) : (
    <div style={{ width: '75%', textAlign: 'left' }}>
      <BackButton />
      <h4 style={{ color: '#596274' }}>PUBLICATION</h4>

      <div className="detail-card">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          {item?.title && <h2 className="detail-title">{item.title}</h2>}

          {item?.status === 'approved' && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                padding: 0,
                margin: 0,
              }}
            >
              {isEditor && item?.status === 'approved' && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: 0,
                    margin: 0,
                  }}
                >
                  {show ? (
                    <Tooltip title="Visible to Members">
                      <VisibilityOutlinedIcon
                        style={{ color: '#356AC3' }}
                        className="detail-icon clickable"
                        onClick={(event) => hideContent(event)}
                        aria-label="Content is visible"
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title="Hidden To Members">
                      <VisibilityOffOutlinedIcon
                        style={{ color: '#356AC3' }}
                        className="detail-icon clickable"
                        onClick={(event) => hideContent(event)}
                        aria-label="Content is hidden"
                      />
                    </Tooltip>
                  )}
                  <FontAwesomeIcon
                    color="#356AC3"
                    icon={faPenToSquare}
                    className="detail-icon clickable"
                    onClick={(event) => editContent(event)}
                  ></FontAwesomeIcon>
                  <AlertDialog
                    id={item._id}
                    action={() =>
                      handleDelete({
                        id: item._id,
                        collection: category + 's',
                        verticalId: vertical_id,
                        parent_id: item?.paperId,
                        otherIds: item?.authors?.map((author) => author.authorId) ?? [],
                        bookmarked: item?.isBookmarked,
                      })
                    }
                    index={-1}
                    dialogTitle={`Delete ${category}: ${item?.title}`}
                    dialogContentText={`This action cannot be undone. This will permanently delete the ${category} and remove the data from our servers.`}
                    color="blue"
                  />
                </div>
              )}
              {item?.status === 'approved' &&
                (item?.isBookmarked ? (
                  <BookmarkIcon
                    className="detail-icon clickable"
                    onClick={(e) => toggleBookmark(e, item._id, `${category}`)}
                    style={{ color: '#356AC3' }}
                  />
                ) : (
                  <BookmarkBorderIcon
                    className="detail-icon clickable"
                    onClick={(e) => toggleBookmark(e, item._id, category)}
                    style={{ color: '#356AC3' }}
                  />
                ))}
            </div>
          )}
        </div>

        {item?.authors?.length > 0 && (
          <div className="detail-item" style={{ color: 'green' }}>
            <PeopleOutlinedIcon className="detail-icon-" />
            <div className="people">
              {item?.authors?.map((author, index) => (
                <div key={author.authorId}>
                  <Link to={`${urlPrefix}author/${author.authorId}`}>
                    <span>{author.name}</span>
                  </Link>
                  {index < item.authors.length - 1 && <span>,&nbsp;</span>}
                </div>
              ))}
            </div>
          </div>
        )}

        {item?.venue && (
          <div className="detail-item">
            <BookOutlinedIcon className="detail-icon-" />
            {item.venue}
          </div>
        )}

        {item?.publicationType && (
          <div className="detail-item">
            <FormatQuoteOutlinedIcon className="detail-icon-" />
            <span>Publication Type: {item.publicationType}</span>
          </div>
        )}

        {item?.publicationDate && (
          <div className="detail-item">
            <CalendarMonthOutlinedIcon className="detail-icon-" />
            {item.publicationDate}
          </div>
        )}

        {(item?.citationCount !== undefined ||
          item?.influentialCitationCount !== undefined ||
          item?.referenceCount !== undefined) && (
          <div className="detail-item">
            <FormatQuoteOutlinedIcon className="detail-icon-" />
            {item?.citationCount !== undefined && (
              <span>Citations: {item.citationCount}&nbsp;&#x2022;&nbsp;</span>
            )}
            {item?.influentialCitationCount !== undefined && (
              <span>
                Influential Citations: {item.influentialCitationCount}
                &nbsp;&#x2022;&nbsp;
              </span>
            )}
            {item?.referenceCount !== undefined && <span>References: {item.referenceCount}</span>}
          </div>
        )}

        {item?.s2FieldsOfStudy?.some((field) => field.source === 's2-fos-model') && (
          <div className="detail-item">
            <TopicOutlinedIcon className="detail-icon-" />
            {item.s2FieldsOfStudy.map(
              (field, index) =>
                field.source === 's2-fos-model' && (
                  <span key={index}>{field.category}&nbsp;&#x2022;&nbsp;</span>
                )
            )}
          </div>
        )}

        {item?.researchMethods && (
          <div className="detail-item">
            <TravelExploreOutlinedIcon className="detail-icon-" />
            <span>Research Methods: {item.researchMethods}</span>
          </div>
        )}

        {item?.peerReviewed && (
          <div className="detail-item">
            <ContentPasteSearchOutlinedIcon className="detail-icon-" />
            <span>Peer Reviewed: {item.peerReviewed}</span>
          </div>
        )}

        {item?.impactFactor && (
          <div className="detail-item">
            <TrendingUpOutlinedIcon className="detail-icon-" />
            <span>Impact Factor: {item.impactFactor}</span>
          </div>
        )}

        {item?.externalIds?.DOI && (
          <div className="detail-item">
            <img src={`${process.env.PUBLIC_URL}/doi.svg`} alt="DOI" className="detail-icon-" />
            <a target="_blank" href={'https://doi.org/' + item.externalIds.DOI}>
              {item.externalIds.DOI}
            </a>
          </div>
        )}

        {item?.tldr?.text && (
          <div style={{ padding: '0 10px' }}>
            <h2 className="detail-title">TLDR</h2>
            <p style={{ margin: 0, textAlign: 'justify' }}>{item.tldr.text}</p>
            <br></br>
          </div>
        )}

        {item?.abstract && (
          <div style={{ padding: '0 10px' }}>
            <h2 className="detail-title">Abstract</h2>
            <p style={{ margin: 0, textAlign: 'justify' }}>{item.abstract}</p>
            <br></br>
          </div>
        )}

        {item?.fundingSource && (
          <div style={{ padding: '0 10px' }}>
            <h2 className="detail-title">Funding Source</h2>
            <p style={{ margin: 0, textAlign: 'justify' }}>{item.fundingSource}</p>
            <br></br>
          </div>
        )}

        <div className="detail-item">
          <PictureAsPdfOutlinedIcon className="detail-icon-" />
          {item?.openAccessPdf?.url ? (
            <a
              href={
                item.openAccessPdf.url.startsWith('http://') ||
                item.openAccessPdf.url.startsWith('https://')
                  ? item.openAccessPdf.url
                  : `https://${item.openAccessPdf.url}`
              }
              target="_blank"
            >
              {item.title + '.pdf'}
            </a>
          ) : (
            <p>No PDF available</p>
          )}
        </div>
      </div>

      {item?.citations?.length > 0 && (
        <>
          <h4>Citations</h4>
          <div>
            {item.citations.map((citation, index) => (
              <Card
                key={index}
                category={'papers'}
                details={citation}
                cardHeader={'PUBLICATION'}
                icons={icons}
                dotColor={'orange'}
                vertical_id={item.vertical_id}
                depth={1}
              />
            ))}
          </div>
        </>
      )}

      {item?.references?.length > 0 && (
        <>
          <h4>References</h4>
          <div>
            {item.references.map((reference, index) => (
              <Card
                key={index}
                category={'papers'}
                details={reference}
                cardHeader={'PUBLICATION'}
                icons={icons}
                dotColor={'orange'}
                vertical_id={item.vertical_id}
                depth={1}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};
export default PublicationPage;
